<template>
  <div class="card card-development-objective">
    <div class="card-header">
      <div class="row no-gutters">
        <div class="col d-flex align-items-center">
          <h3 class="mb-0">{{ objective.description }}</h3>
        </div>

        <div class="col-auto d-flex align-items-center"></div>
      </div><!-- /.row -->
    </div>

    <ul class="list-data no-hover">
      <li class="data-heading">
        <div class="row">
          <div class="col">Method</div>
        </div><!-- /.row -->
      </li>

      <li>
        <div class="row">
          <div class="col-12 pt-3 pb-3">
            <div class="form-check abc-checkbox abc-checkbox-success form-check-inline">
              <input
                class="form-check-input"
                type="checkbox"
                :checked="objective.education"
                value="Education"
                disabled>
              <label class="form-check-label" :for="`checkEducation${objective.id}`">Education</label>
            </div>

            <div class="form-check abc-checkbox abc-checkbox-success form-check-inline">
              <input
                class="form-check-input"
                type="checkbox"
                value="Experience"
                :checked="objective.experience"
                disabled>

              <label class="form-check-label" :for="`checkExperience${objective.id}`">Experience</label>
            </div>

            <div class="form-check abc-checkbox abc-checkbox-success form-check-inline">
              <input
                class="form-check-input"
                type="checkbox"
                value="Exposure"
                :checked="objective.exposure"
                disabled>
              <label class="form-check-label" :for="`checkExposure${objective.id}`">Exposure</label>
            </div>
          </div>
        </div><!-- /.row -->
      </li>
    </ul>
    <ul class="list-data no-hover">
      <li class="data-heading">
        <div class="row">
          <div class="col-12 col-lg-7">
            <p>Action Steps</p>
          </div>

          <div class="col-6 col-lg-2">
            <p>Start Date</p>
          </div>

          <div class="col-6 col-lg-2">
            <p>End Date</p>
          </div>
        </div><!-- /.row -->
      </li>

      <li v-for="action in actions" :key="action.id">
        <div class="row">
          <div class="col-12 col-lg-7">
            <div class="form-control-plaintext quill-html"><div v-html="action.description" /></div>
          </div>

          <div class="col-6 col-lg-2">
            <span class="sr-only">Key milestone start date</span>
            <p class="form-control-plaintext">{{ action.start_date | date('YYYY-MM-DD') }}</p>
          </div>

          <div class="col-6 col-lg-2">
            <span class="sr-only">Key milestone end date</span>
            <p class="form-control-plaintext">{{ action.end_date | date('YYYY-MM-DD') }}</p>
          </div>

          <div class="col-auto d-flex align-items-center"></div>
        </div><!-- /.row -->
      </li>
    </ul><!-- /.list-data -->
  </div><!-- /.card -->
</template>
<script>
export default {
  props: {
    objective: {
      required: true,
      type: Object
    }
  },

  computed: {
    actions () {
      return this.objective.actions
    }
  }
}
</script>
